import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { login } from '../../../../shared/utils/auth/auth'

const StyledWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  background: var(--yellow);
  font-size: 1rem;
`

const StyledButton = styled.button`
  padding: 0;
  color: var(--dark);
  text-decoration: underline;
  text-underline-offset: 0.2rem;
  background: transparent;

  &:hover {
    text-decoration: none;
  }
`

const ParagraphSmall = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin: 0.5rem 0;
`

const ParagraphSmallBold = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 700;
  margin: 0;
`

const RestrictedLayerCollectionAlert: FunctionComponent = () => {
  return (
    <StyledWrapper>
      <ParagraphSmallBold>Afgeschermde dataset</ParagraphSmallBold>
      <ParagraphSmall>
        Om te bepalen of u deze dataset kunt inzien moet u eerst inloggen.
      </ParagraphSmall>
      <StyledButton onClick={login}>Klik hier om in te loggen</StyledButton>
    </StyledWrapper>
  )
}

export default RestrictedLayerCollectionAlert
